var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBerlin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.225,41.686c0-3.522-1.985-6.586-4.894-8.14v-3.405c0-1.104-0.896-2-2-2H50V17.639c0-1.104-0.896-2-2-2s-2,0.896-2,2 v10.501h-0.331c-1.104,0-2,0.896-2,2v3.405c-2.908,1.554-4.894,4.618-4.894,8.14c0,3.493,1.951,6.538,4.821,8.104l-2.163,28.419 c-0.042,0.555,0.149,1.103,0.527,1.511s0.91,0.641,1.467,0.641h9.145c0.557,0,1.089-0.232,1.467-0.641 c0.379-0.408,0.569-0.956,0.527-1.511L52.404,49.79C55.273,48.224,57.225,45.179,57.225,41.686z M47.669,32.461v-0.32h0.662v0.32 H47.669z M48,36.461c2.881,0,5.225,2.344,5.225,5.225c0,2.881-2.344,5.225-5.225,5.225s-5.225-2.344-5.225-5.225 C42.775,38.805,45.119,36.461,48,36.461z M48.478,50.91l1.937,25.45h-4.828l1.937-25.45h0.458c0.007,0,0.013,0.001,0.019,0.001 s0.013-0.001,0.019-0.001H48.478z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBerlin);
export default __webpack_public_path__ + "static/media/berlin.6de87f1a1889a9a8fb7f973c2d058572.svg";
export { ForwardRef as ReactComponent };